<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <title-text />
      </b-col>
      <b-col
        cols="12"
      >
        <content-text />
      </b-col>
      <b-col cols="12">
        <hr>
      </b-col>
      <b-col cols="12">
        <vision-mission-title />
        <vision-mission-content />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <vision-title />
        <vision />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <mission-title />
        <mission />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import TitleText from '@/views/Admin/About/elements/TitleText.vue'
import ContentText from '@/views/Admin/About/elements/ContentText.vue'
import { BCard, BCol, BRow } from 'bootstrap-vue'
import VisionTitle from '@/views/Admin/About/elements/VisionTitle.vue'
import Vision from '@/views/Admin/About/elements/Vision.vue'
import MissionTitle from '@/views/Admin/About/elements/MissionTitle.vue'
import Mission from '@/views/Admin/About/elements/Mission.vue'
import VisionMissionTitle from '@/views/Admin/About/elements/VisionMissionTitle.vue'
import VisionMissionContent from '@/views/Admin/About/elements/VisionMissionContent.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    VisionMissionTitle,
    VisionMissionContent,
    VisionTitle,
    MissionTitle,
    Mission,
    Vision,
    ContentText,
    TitleText,
  },
}
</script>
